export function percentage(input: number, total: number) {
  if (total <= 0) {
    return '0%';
  }

  const percentage = (input * 100) / total;
  const hasDecimalPoints = percentage % 1 !== 0;

  if (hasDecimalPoints) {
    return `${percentage.toFixed(1)}%`;
  }

  return `${percentage}%`;
}
